<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_tomaio') }}
      </h3>
      <hr />
    </div>
    <div class="columns">
      <div class="column is-8">
        <div class="columns">
          <div class="column is-3">
            <b-button
              v-if="totalPel < $moduleConfiguration[module].maxPel && !orderbool"
              :disabled="disabledbool"
              @click="totalPel++"
              type="is-primary"
            >
              {{ $translate('add_pel') }}
            </b-button>
          </div>
          <div class="column is-3">
            <b-button
              v-if="totalPel > 1 && $moduleConfiguration[module].minPel === 1 && !orderbool"
              :disabled="disabledbool"
              @click="handleRemovePel"
              type="is-primary"
            >
              {{ $translate('remove_pel') }}
            </b-button>
          </div>
        </div>
        <TomaioRepeater
          v-for="index in totalPel"
          :key="`pell-${index}`"
          :availablepell="
            $moduleConfiguration[module].hasRestrictedAllestimentoTomaia && orderbool
              ? availablepell[index]
              : availablepell
          "
          :availableallestimenti="availableallestimenti"
          :pellmat="mod[`pell${index}mat`]"
          :pellvar="mod[`pell${index}var`]"
          :pellallestimento="mod[`pell${index}allestimento`]"
          :image="getImagePel(index)"
          :pell-index="index"
          :material-name="'pell'"
          :is-disabled="disabledbool"
          :is-required="
            orderInfoMandatory &&
              ($moduleConfiguration[module].minPel !== $moduleConfiguration[module].maxPel
                ? index <= $moduleConfiguration[module].minPel
                : index === 1)
          "
          :orderbool="orderbool"
          :hasAllestimento="
            $moduleConfiguration[module].hasRestrictedAllestimentoTomaia && !orderbool && !mod.uniqueComposition
          "
          @changePell="changePel"
          @changeImage="changeImagePel"
          @changeAllestimento="changeAllestimento"
        />
        <template v-if="$moduleConfiguration[module].materials.Rip">
          <div class="columns">
            <div class="column is-3">
              <b-button
                v-if="totalRip < $moduleConfiguration[module].maxRip && !orderbool"
                @click="totalRip++"
                type="is-primary"
              >
                {{ $translate('add_rip') }}
              </b-button>
            </div>
            <div class="column is-3">
              <b-button
                v-if="totalRip > 0 && $moduleConfiguration[module].minRip === 0 && !orderbool"
                @click="handleRemoveRip"
                type="is-primary"
              >
                {{ $translate('remove_rip') }}
              </b-button>
            </div>
          </div>
          <TomaioRepeater
            v-for="index in totalRip"
            :key="`rip-${index}`"
            :availablerip="
              $moduleConfiguration[module].hasRestrictedAllestimentoTomaia && orderbool
                ? availablerip[index]
                : availablerip
            "
            :availableallestimenti="availableallestimenti"
            :pellmat="mod[`rip${index}mat`]"
            :pellvar="mod[`rip${index}var`]"
            :pellallestimento="mod[`rip${index}allestimento`]"
            :material-name="'rip'"
            :image="getImageRip(index)"
            :pell-index="index"
            :is-disabled="disabledbool"
            :is-required="
              orderInfoMandatory ||
                ((mod.custom && !mod.from_duna_catalog) || $moduleConfiguration[module].minRip === 0)
            "
            :orderbool="orderbool"
            :has-allestimento="
              $moduleConfiguration[module].hasRestrictedAllestimentoTomaia && !orderbool && !mod.uniqueComposition
            "
            @changePell="changePel"
            @changeImage="changeImageRip"
            @changeAllestimento="changeAllestimento"
          />
        </template>
      </div>
      <div class="column">
        <b-field :label="$translate('addingchar') | capitalize">
          <div class="multiselect-list" :class="{ 'is-disabled': orderbool }">
            <div
              v-for="option in optionsaddingchar"
              :key="option"
              class="multiselect-option"
              :class="{ 'is-selected': mod.addingchar && mod.addingchar.includes(option) }"
              @click="!orderbool && toggleAddingchar(option)"
            >
              {{ option }}
            </div>
            <span v-if="!optionsaddingchar.length" class="has-text-grey-light multiselect-placeholder">
              {{ $translate('placeholder_select') | capitalize }}
            </span>
          </div>
        </b-field>
        <p class="content">* {{ $translate('multiple_select_info') | capitalize }}</p>
        <b-field :label="$translate('puncture') | capitalize" horizontal>
          <b-checkbox
            v-model="mod.puncture"
            :disabled="disabledbool || (!$moduleConfiguration[module].hasCustomTomaiaDrills && orderbool)"
            @input="managePuncture"
          />
        </b-field>
        <template v-if="$moduleConfiguration[module].hasCustomTomaiaDrills">
          <b-field
            :label="$translate('type') | capitalize"
            :message="errors.first('passing')"
            :type="{ 'is-danger': errors.has('passing') }"
          >
            <b-select
              v-model="mod.passing"
              v-validate="{ required: !!mod.puncture }"
              name="passing"
              :placeholder="$translate('placeholder_select')"
              :disabled="!mod.puncture || disabledbool"
            >
              >
              <option value="passing">
                {{ $translate('passing') }}
              </option>
              <option value="not_passing">
                {{ $translate('not_passing') }}
              </option>
            </b-select>
          </b-field>
          <b-field :label="$translate('components_to_drill') | capitalize">
            <b-select
              v-model="mod.components_to_drill"
              multiple
              name="components_to_drill"
              :disabled="!mod.puncture || components_to_drillbool || disabledbool"
            >
              <option value="mask">
                {{ $translate('mask') }}
              </option>
              <option value="bowl">
                {{ $translate('bowl') }}
              </option>
              <option value="quarter">
                {{ $translate('quarter') }}
              </option>
              <option value="gambetti">
                {{ $translate('gambetti') }}
              </option>
            </b-select>
          </b-field>
          <p class="content">* {{ $translate('multiple_select_info') | capitalize }}</p>

          <b-field :label="$translate('like_photo') | capitalize" horizontal>
            <b-checkbox v-model="mod.like_photo" :disabled="!mod.puncture || disabledbool" @input="likePhoto" />
          </b-field>

          <b-field :label="$translate('seams') | capitalize" horizontal>
            <b-checkbox v-model="mod.seams" :disabled="disabledbool" />
          </b-field>
          <template v-if="mod.seams">
            <b-radio v-model="mod.matching" name="matching" native-value="matching" :disabled="disabledbool">
              {{ $translate('matching') }} </b-radio
            ><br />
            <b-radio v-model="mod.matching" name="matching" native-value="not_matching" :disabled="disabledbool">
              {{ $translate('not_matching') }}
            </b-radio>
            <b-input v-model="mod.notmatchingstring" :disabled="mod.matching != 'not_matching' || disabledbool" />
          </template>
        </template>
      </div>
    </div>

    <!--    <div v-if="$moduleConfiguration[module].hasRestrictedAllestimentoTomaia && !orderbool">-->
    <!--      <hr class="green" />-->
    <!--      <h3 class="green subtitle">-->
    <!--        {{ $translate('subtitle_form_model_tomaio_possible_allestimento') }}-->
    <!--      </h3>-->
    <!--      <hr />-->
    <!--      <div class="columns">-->
    <!--        <div v-if="availablepell" class="column is-6">-->
    <!--          <b-field-->
    <!--            horizontal-->
    <!--            :label="$translate('available_pel') | capitalize"-->
    <!--            :message="errors.first('available_pel')"-->
    <!--            :type="{ 'is-danger': errors.has('available_pel') }"-->
    <!--          >-->
    <!--            <b-select-->
    <!--              class="select-is-large"-->
    <!--              v-model="mod.possiblePel"-->
    <!--              v-validate="'required'"-->
    <!--              data-vv-validate-on="blur"-->
    <!--              name="available_pel"-->
    <!--              multiple-->
    <!--            >-->
    <!--              <option v-for="pel in availablepell" :key="pel.id" :value="pel.id">-->
    <!--                {{ pel.commercial_name }}-->
    <!--              </option>-->
    <!--            </b-select>-->
    <!--          </b-field>-->
    <!--        </div>-->
    <!--        <div v-if="availablerip" class="column is-6">-->
    <!--          <b-field horizontal :label="$translate('available_rip') | capitalize">-->
    <!--            <b-select-->
    <!--              v-model="mod.possibleRip"-->
    <!--              class="select-is-large"-->
    <!--              data-vv-validate-on="blur"-->
    <!--              name="available_rip"-->
    <!--              multiple-->
    <!--            >-->
    <!--              <option v-for="rip in availablerip" :key="rip.id" :value="rip.id">-->
    <!--                {{ rip.commercial_name }}-->
    <!--              </option>-->
    <!--            </b-select>-->
    <!--            <b-button @click="$emit('onReset')" type="is-primary">-->
    <!--              {{ $translate('reset_rip') }}-->
    <!--            </b-button>-->
    <!--          </b-field>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/seasontag'
import TomaioRepeater from '@/views/Mod/components/tomaio-repeater.vue'

export default {
  name: 'Tomaio',
  components: { TomaioRepeater },
  props: [
    'orderbool',
    'mod',
    'availablepell',
    'availablerip',
    'availableallestimenti',
    'disabledbool',
    'orderInfoMandatory',
    'module',
  ],
  data() {
    return {
      imagePel1: null,
      imagePel2: null,
      imagePel3: null,
      imagePel4: null,
      imagePel5: null,
      imagePel6: null,
      imagePel7: null,
      imagePel8: null,
      imagePel9: null,
      imagePel10: null,
      imageRip1: null,
      imageRip2: null,
      imageRip3: null,
      imageRip4: null,
      imageRip5: null,
      imageRip6: null,
      imageRip7: null,
      imageRip8: null,
      imageRip9: null,
      imageRip10: null,
      optionsaddingchar: [],
      components_to_drillbool: false,
      // eslint-disable-next-line vue/no-reserved-keys
      totalPel: this.$moduleConfiguration[this.module].minPel,
      totalRip: this.$moduleConfiguration[this.module].minRip,
    }
  },
  inject: ['$validator'],

  watch: {
    mod: function(newMod, oldMod) {
      if (newMod !== oldMod) this.updateAfterload()
    },
  },
  methods: {
    toggleAddingchar(option) {
      if (!this.mod.addingchar) this.$set(this.mod, 'addingchar', [])
      const idx = this.mod.addingchar.indexOf(option)
      if (idx === -1) this.mod.addingchar.push(option)
      else this.mod.addingchar.splice(idx, 1)
    },
    managePuncture() {
      if (!this.mod.puncture && this.$moduleConfiguration[this.module].hasCustomTomaiaDrills) {
        this.$set(this.mod, 'puncture', false)
        this.$set(this.mod, 'passing', null)
        this.$set(this.mod, 'like_photo', null)
        this.mod.components_to_drill = []
      }
    },
    likePhoto() {
      if (this.mod.like_photo) {
        this.mod.components_to_drill = []
        this.$forceUpdate()
      }
      this.components_to_drillbool = this.mod.like_photo
    },
    resetTag(typeOfMaterial, append = false) {
      const config = this.$moduleConfiguration[this.module] || {}
      if (!append) this.optionsaddingchar = []
      const maxIndex = typeOfMaterial === 'pell' ? this.totalPel : this.totalRip
      const materials = typeOfMaterial === 'pell' ? this.availablepell : this.availablerip
      const hasData = Array.isArray(materials) ? materials.length > 0 : materials && Object.keys(materials).length > 0
      if (hasData) {
        for (let i = 1; i <= maxIndex; i++) {
          let mat
          if (!config.hasRestrictedAllestimentoTomaia || !this.orderbool) {
            mat = materials.find(temp => temp.id === this.mod[`${typeOfMaterial}${i}mat`])
          } else {
            const list = materials[i] || []
            mat = list.find(temp => temp.id === this.mod[`${typeOfMaterial}${i}mat`])
          }
          if (mat) {
            for (let indexTag in mat.optional_tag) {
              if (!this.optionsaddingchar.includes(mat.optional_tag[indexTag].key)) {
                this.optionsaddingchar.push(mat.optional_tag[indexTag].key)
              }
            }
          }
        }
      }
    },
    changePel(material, index) {
      const config = this.$moduleConfiguration[this.module] || {}
      if (this.availablepell) {
        let isPel = false
        if (!config.hasRestrictedAllestimentoTomaia || !this.orderbool) {
          isPel = this.availablepell.some(pell => pell.id === material)
        } else {
          if (this.availablepell[index]) {
            isPel = this.availablepell[index].some(pell => pell.id === material)
          }
        }
        if (isPel) {
          this.$set(this.mod, `pell${index}var`, null)
          this.$set(this.mod, `pell${index}mat`, material)
          this[`imagePel${index}`] = null
          this.resetTag('pell')
          if (this.$moduleConfiguration[this.module].materials.Rip) this.resetTag('rip', true)
          return
        }
      }
      if (this.availablerip) {
        let isRip = false
        if (!config.hasRestrictedAllestimentoTomaia || !this.orderbool) {
          isRip = this.availablerip.some(rip => rip.id === material)
        } else {
          if (this.availablerip[index]) {
            isRip = this.availablerip[index].some(rip => rip.id === material)
          }
        }
        if (isRip) {
          this.$set(this.mod, `rip${index}var`, null)
          this.$set(this.mod, `rip${index}mat`, material)
          this[`imageRip${index}`] = null
          this.resetTag('pell')
          if (this.$moduleConfiguration[this.module].materials.Rip) this.resetTag('rip', true)
        }
      }
    },
    changeImagePel(variant, i) {
      const config = this.$moduleConfiguration[this.module] || {}
      this.resetTag('pell')
      if (this.$moduleConfiguration[this.module].materials.Rip) this.resetTag('rip', true)
      this[`imagePel${i}`] = null
      this.$set(this.mod, `pell${i}var`, variant)
      const materials =
        !config.hasRestrictedAllestimentoTomaia || !this.orderbool ? this.availablepell : this.availablepell[i]
      for (let index in materials) {
        if (materials[index].id === this.mod[`pell${i}mat`]) {
          for (let index2 in materials[index].variants) {
            if (materials[index].variants[index2].id === this.mod[`pell${i}var`]) {
              this[`imagePel${i}`] = materials[index].variants[index2].image
            }
          }
        }
      }
    },
    getImagePel(i) {
      return this[`imagePel${i}`]
    },
    changeImageRip(variant, i) {
      const config = this.$moduleConfiguration[this.module] || {}
      this.resetTag('pell')
      if (this.$moduleConfiguration[this.module].materials.Rip) this.resetTag('rip', true)
      this[`imageRip${i}`] = null
      this.$set(this.mod, `rip${i}var`, variant)
      const materials =
        !config.hasRestrictedAllestimentoTomaia || !this.orderbool ? this.availablerip : this.availablerip[i]
      for (let index in materials) {
        if (materials[index].id === this.mod[`rip${i}mat`]) {
          for (let index2 in materials[index].variants) {
            if (materials[index].variants[index2].id === this.mod[`rip${i}var`]) {
              this[`imageRip${i}`] = materials[index].variants[index2].image
            }
          }
        }
      }
    },
    getImageRip(i) {
      return this[`imageRip${i}`]
    },
    handleRemovePel() {
      delete this.mod[`pell${this.totalPel}mat`]
      delete this.mod[`pell${this.totalPel}var`]
      delete this.mod[`pell${this.totalPel}allestimento`]
      if (this.mod.possiblePel) delete this.mod.possiblePel[this.totalPel]
      this.totalPel--
    },
    handleRemoveRip() {
      delete this.mod[`rip${this.totalRip}mat`]
      delete this.mod[`rip${this.totalRip}var`]
      delete this.mod[`rip${this.totalRip}allestimento`]
      if (this.mod.possibleRip) delete this.mod.possibleRip[this.totalRip]
      this.totalRip--
    },
    changeAllestimento(allestimentoId, index, materialName) {
      if (this.availableallestimenti && this.availableallestimenti.length > 0) {
        const allestimento = this.availableallestimenti.find(a => a.id === allestimentoId)
        if (materialName === 'Pel_M') {
          this.mod[`pell${index}allestimento`] = allestimentoId
          this.mod.possiblePel = { ...this.mod.possiblePel, [index]: allestimento[materialName] }
        }
        if (materialName === 'Rip_M') {
          this.mod[`rip${index}allestimento`] = allestimentoId
          this.mod.possibleRip = { ...this.mod.possibleRip, [index]: allestimento[materialName] }
        }
      }
    },
    updateAfterload() {
      const config = this.$moduleConfiguration[this.module] || {}
      if (!this.mod.components_to_drill) this.$set(this.mod, 'components_to_drill', [])
      if (!this.mod.addingchar) this.$set(this.mod, 'addingchar', [])
      for (let i = 1; i <= this.totalPel; i++) {
        const pelVariant = this.mod[`pell${i}var`]
        if (pelVariant) this.changeImagePel(pelVariant, i)
      }
      if (config.materials.Rip) {
        for (let i = 1; i <= this.totalRip; i++) {
          const ripVariant = this.mod[`rip${i}var`]
          if (ripVariant) this.changeImageRip(ripVariant, i)
        }
      }
      const { maxPel, minPel } = config
      if (maxPel !== minPel) {
        let lastPel = 0
        let lastRip = 0
        for (const key of Object.keys(this.mod || {})) {
          const pelMatch = key.match(/^pell(\d+)mat$/)
          if (pelMatch && this.mod[key] != null && Number(pelMatch[1]) > lastPel) lastPel = Number(pelMatch[1])
          const ripMatch = key.match(/^rip(\d+)mat$/)
          if (ripMatch && this.mod[key] != null && Number(ripMatch[1]) > lastRip) lastRip = Number(ripMatch[1])
        }
        this.totalPel = lastPel > 0 ? lastPel : 1
        this.totalRip = lastRip
      } else {
        this.totalPel = maxPel
      }
      this.resetTag('pell')
      if (config.materials.Rip) this.resetTag('rip', true)
    },
  },
}
</script>
<style scoped>
.container >>> .field-label {
  text-align: left;
}
.select-is-large >>> select {
  min-width: 300px;
  min-height: 300px;
  overflow-x: auto;
}
.multiselect-list {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  min-width: 300px;
  min-height: 120px;
  max-height: 200px;
  overflow-y: auto;
  background: white;
}
.multiselect-list.is-disabled {
  background-color: #f5f5f5;
  pointer-events: none;
}
.multiselect-option {
  padding: 0.35rem 0.75rem;
  white-space: normal;
  cursor: pointer;
  line-height: 1.4;
}
.multiselect-option:hover {
  background-color: #f5f5f5;
}
.multiselect-option.is-selected {
  background-color: #3273dc;
  color: white;
}
.multiselect-placeholder {
  display: block;
  padding: 0.35rem 0.75rem;
}
</style>
